import { FSA } from 'flux-standard-action';
import {
  LOCATION_FETCH_REQUESTED,
  LOCATION_FETCH_SUCCEEDED,
  LOCATION_FETCH_FAILED,
  LOCATION_SAVE_REQUESTED,
  LOCATION_SAVE_SUCCEEDED,
  LOCATION_SAVE_FAILED,
  LOCATION_DELETE_REQUESTED,
  LOCATION_DELETE_SUCCEEDED,
  LOCATION_DELETE_FAILED,
} from './action-types';

type state = {
  status: string;
  data: { [key: string]: any };
};

const initialState: state = {
  status: '',
  data: {},
};

export default function reducer(state = initialState, action: FSA<any, any>) {
  switch (action.type) {
    case LOCATION_FETCH_REQUESTED:
      return { ...state, status: 'loading' };
    case LOCATION_FETCH_SUCCEEDED: {
      let data = action.payload;

      if (__USE_FAKE_DATA__) {
        data = Object.values<any>(action.payload).reduce((agg, cur) => {
          agg[cur.id] = {
            ...cur,
            name: 'Springfield',
          };
          return agg;
        }, {});
      }

      return {
        ...state,
        status: 'done',
        data: {
          ...state.data,
          ...data,
        },
      };
    }
    case LOCATION_FETCH_FAILED:
      return { ...state, status: 'failed' };

    case LOCATION_SAVE_REQUESTED:
      return { ...state, status: 'saving' };
    case LOCATION_SAVE_SUCCEEDED: {
      const location = action.payload;
      return {
        ...state,
        status: 'done',
        data: {
          ...state.data,
          [location.id]: location,
        },
      };
    }
    case LOCATION_SAVE_FAILED:
      return { ...state, status: 'failed' };

    case LOCATION_DELETE_REQUESTED:
      return { ...state, status: 'deleting' };
    case LOCATION_DELETE_SUCCEEDED: {
      const { [action.payload]: _, ...nonDeleted } = state.data;
      return {
        ...state,
        status: 'done',
        data: {
          ...nonDeleted,
        },
      };
    }
    case LOCATION_DELETE_FAILED:
      return { ...state, status: 'failed' };

    default:
      return state;
  }
}
